import type { PromptBlockFragment } from "@app_schema";

// The template page: every version of a shared prompt.
export const promptTemplatePath = (block: Pick<PromptBlockFragment, "name">) =>
  `/dashboard/prompts/${block.name}`;

// One version's editor.
export const promptBlockPath = (
  block: Pick<PromptBlockFragment, "name" | "version">,
) => `/dashboard/prompts/${block.name}/${block.version}`;

export const promptBlockTargetsPath = (
  block: Pick<PromptBlockFragment, "name" | "version">,
) => `${promptBlockPath(block)}/targets`;

export const newPromptBlockVersionPath = (
  block: Pick<PromptBlockFragment, "name">,
) => `${promptTemplatePath(block)}/versions/new`;
